import { observer } from 'mobx-react';
import { ExperienceResource } from '../../Types';
import ProgramProductBadge from './ProgramProductBadge';
import ProgramSequenceProductBadge from './ProgramSequenceProductBadge';

interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceProductBadge({ experienceResource }: Props) {
  switch (experienceResource.payload.offering_type) {
    case 'aep':
    case 'epc':
    case 'msuite':
    case 'coaching':
    case 'group-coaching':
      return <ProgramProductBadge experienceResource={experienceResource} />;
    case 'program-sequence':
      return <ProgramSequenceProductBadge />;
  }
}

export default observer(ExperienceProductBadge);
